import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { formatTimestamp } from "@covertree/utils/time/formatTimestamp";
import { Resident } from "@graphql/api";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}
export default function ResidentsDatesDetails({ isLoading, resident }: Props) {
  return (
    <DisplayPropertiesCard
      properties={[
        {
          label: "Created Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.createdAt
                  ? formatTimestamp(resident.createdAt)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Updated Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.updatedAt
                  ? formatTimestamp(resident.updatedAt)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
      ]}
    />
  );
}
